import namespace from '@/store/namespace';

export default namespace('global', {
  getters: [
    'getToday',
  ],
  mutations: [
  ],
  actions: [
  ],
});
